// JLM Container
// 

var JLM = {};

JLM.NS = {}; // Namespaces
JLM.MD = {}; // Modules
JLM.MT = {}; // Common Methods



// Settings
// 
JLM.environment = 'production'; // development or production



// Namespaces
// 

// Divisions
JLM.NS.DIVISION_ACTORS				= 'actors';
JLM.NS.DIVISION_VOICES				= 'voices';
JLM.NS.DIVISION_CONTENT_CREATORS	= 'content-creators';
JLM.NS.DIVISION_BRAND_AMBASSADORS	= 'brand-ambassadors';
JLM.NS.DIVISION_PRESENTERS			= 'presenters';
JLM.NS.DIVISION_MCS_ENTERTAINERS	= 'mcs-entertainers';
JLM.NS.DIVISION_WRITERS_DIRECTORS	= 'writers-directors';

// Layout types
JLM.NS.LAYOUT_LARGE = 'large';
JLM.NS.LAYOUT_SMALL = 'small';



// Error Reporting
// 
Raven.config('https://2de1f25464b7466ebec43339de3baab2@sentry.io/241771', {
	environment: 'production',
	ignoreErrors: [],
	ignoreUrls: [/local\.johnsonlaird\.com/i,/dev\.johnsonlaird\.com/i]
}).install();
